import { createAction } from 'redux-actions'

import * as constants from './constants'

export const fetchSettings = createAction(constants.FETCH_SETTINGS)
export const fetchSettingsPending = createAction(constants.FETCH_SETTINGS_PENDING)
export const fetchSettingsSuccess = createAction(constants.FETCH_SETTINGS_SUCCESS)
export const fetchSettingsFailed = createAction(constants.FETCH_SETTINGS_FAILED)

export const fetchBotConfig = createAction(constants.FETCH_BOT_CONFIG)
export const fetchBotConfigPending = createAction(constants.FETCH_BOT_CONFIG_PENDING)
export const fetchBotConfigSuccess = createAction(constants.FETCH_BOT_CONFIG_SUCCESS)
export const fetchBotConfigFailed = createAction(constants.FETCH_BOT_CONFIG_FAILED)

export const fetchSyncedKnowledgebaseList = createAction(constants.FETCH_SYNCED_KNOWLEDGEBASE_LIST)
export const fetchSyncedKnowledgebaseListPending = createAction(constants.FETCH_SYNCED_KNOWLEDGEBASE_LIST_PENDING)
export const fetchSyncedKnowledgebaseListSuccess = createAction(constants.FETCH_SYNCED_KNOWLEDGEBASE_LIST_SUCCESS)
export const fetchSyncedKnowledgebaseListFailed = createAction(constants.FETCH_SYNCED_KNOWLEDGEBASE_LIST_FAILED)

export const setBotConfig = createAction(constants.SET_BOT_CONFIG)
export const setBotConfigPending = createAction(constants.SET_BOT_CONFIG_PENDING)
export const setBotConfigSuccess = createAction(constants.SET_BOT_CONFIG_SUCCESS)
export const setBotConfigFailed = createAction(constants.SET_BOT_CONFIG_FAILED)

export const updateSettings = createAction(constants.UPDATE_SETTINGS)
export const updateSettingsPending = createAction(constants.UPDATE_SETTINGS_PENDING)
export const updateSettingsSuccess = createAction(constants.UPDATE_SETTINGS_SUCCESS)
export const updateSettingsFailed = createAction(constants.UPDATE_SETTINGS_FAILED)

export const setDriftHelpDomain = createAction(constants.SET_DRIFT_HELP_DOMAIN)
export const setCnameDomain = createAction(constants.SET_CNAME_DOMAIN)
export const setGoogleAnalyticsCode = createAction(constants.SET_GOOGLE_ANALYTICS_CODE)
export const setTitle = createAction(constants.SET_TITLE)
export const setDescription = createAction(constants.SET_DESCRIPTION)
export const setTagline = createAction(constants.SET_TAGLINE)
export const setFavicon = createAction(constants.SET_FAVICON)
export const setLogo = createAction(constants.SET_LOGO)
export const setColor = createAction(constants.SET_COLOR)

export const appendToDomain = createAction(constants.APPEND_TO_DOMAIN)
export const updateKBNoIndex = createAction(constants.UPDATE_KB_NO_INDEX)

export const setSelectedCustomLink = createAction(constants.SET_SELECTED_CUSTOM_LINK)
export const changeCustomLinkText = createAction(constants.CHANGE_CUSTOM_LINK_TEXT)
export const changeCustomLinkUrl = createAction(constants.CHANGE_CUSTOM_LINK_URL)
export const clearCustomLink = createAction(constants.CLEAR_CUSTOM_LINK)

export const fetchCustomLinks = createAction(constants.FETCH_CUSTOM_LINKS)
export const fetchCustomLinksPending = createAction(constants.FETCH_CUSTOM_LINKS_PENDING)
export const fetchCustomLinksSuccess = createAction(constants.FETCH_CUSTOM_LINKS_SUCCESS)
export const fetchCustomLinksFailed = createAction(constants.FETCH_CUSTOM_LINKS_FAILED)

export const editCustomLink = createAction(constants.EDIT_CUSTOM_LINK)
export const editCustomLinkPending = createAction(constants.EDIT_CUSTOM_LINK_PENDING)
export const editCustomLinkSuccess = createAction(constants.EDIT_CUSTOM_LINK_SUCCESS)
export const editCustomLinkFailed = createAction(constants.EDIT_CUSTOM_LINK_FAILED)

export const saveCustomLink = createAction(constants.SAVE_CUSTOM_LINK)
export const saveCustomLinkPending = createAction(constants.SAVE_CUSTOM_LINK_PENDING)
export const saveCustomLinkSuccess = createAction(constants.SAVE_CUSTOM_LINK_SUCCESS)
export const saveCustomLinkFailed = createAction(constants.SAVE_CUSTOM_LINK_FAILED)

export const deleteCustomLink = createAction(constants.DELETE_CUSTOM_LINK)
export const deleteCustomLinkPending = createAction(constants.DELETE_CUSTOM_LINK_PENDING)
export const deleteCustomLinkSuccess = createAction(constants.DELETE_CUSTOM_LINK_SUCCESS)
export const deleteCustomLinkFailed = createAction(constants.DELETE_CUSTOM_LINK_FAILED)
